var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaccommodation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.75 5.5H2.3c-.28 0-.42 0-.527.054a.5.5 0 0 0-.218.219C1.5 5.88 1.5 6.02 1.5 6.3v4.2m6.75-5H9.7c.28 0 .42 0 .527.054a.5.5 0 0 1 .218.219c.055.107.055.247.055.527v4.2m-2.25 0V3.1c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C7.49 1.5 7.21 1.5 6.65 1.5h-1.3c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3.75 2.26 3.75 2.54 3.75 3.1v7.4m7.25 0H1m4.5-7h1m-1 2h1m-1 2h1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaccommodation);
export default __webpack_public_path__ + "static/media/vaccommodation.a4219102123cd4d2753c84eaa18ec5ca.svg";
export { ForwardRef as ReactComponent };